import { ca } from '@cian/analytics';

type TPageExtra = {
  review_id?: string;
  question_id?: string;
};

type TPage = {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: TPageExtra;
};

export function trackOpenThread(page: TPage) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'NewbuildingReviews',
    label: 'thred',
    name: 'oldevent',
    page,
  });
}
